import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    > button {
        width: 100% !important;
    }
`;

export const TextWrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    > p {
        text-align: center;
    }
`;

export const MailToLink = styled('a')`
    font-weight: bold;
    color: inherit;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
